export default __webpack_public_path__ + "static/media/wall-clock1.09cb2125.png";